<script>
import DefaultLayout from '../layouts/Default'
import UserLine from '../components/UserLine'

export default {
  name: 'Users',
  components: {
    UserLine,
    DefaultLayout,
  },
  data() {
    return {
      ui: {
        disabled: false,
      },
    }
  },
  computed: {
    currentUser() { return this.$store.state.user.current },
    currentCompany() { return this.$store.state.company.current },
    subordinates() { return this.$store.getters['user/subordinates'] },
    chiefs() { return this.$store.getters['user/chiefs'] },
    unrelated() { return this.$store.getters['user/unrelated'] },
    loading() {
      const { $store, currentUser, currentCompany } = this
      return currentUser === null ||
        $store.getters['user/list'] === null ||
        currentCompany === null
    },
  },
  created() {
    this.$store.dispatch('user/getList', { reload: true })
  },
  methods: {
    isSubbed(userId) {
      const { currentUser } = this
      return currentUser && currentUser.follow.includes(userId)
    },
    follow(userId) {
      const { $store, ui } = this
      ui.disabled = true
      $store.dispatch('user/follow', { userId })
        .finally(() => { ui.disabled = false })
    },
    unfollow(userId) {
      const { $store, ui } = this
      ui.disabled = true
      $store.dispatch('user/unfollow', { userId })
        .finally(() => { ui.disabled = false })
    },
  },
}
</script>

<template>
  <DefaultLayout class="UsersView">
    <h1 class="mb-0 display-1">
      Все пользователи
    </h1>
    <h1 class="mb-4 subtitle-1 grey--text">
      Компания &laquo;{{ currentCompany.name }}&raquo;
    </h1>

    <VSkeletonLoader
      type="article@3"
      :loading="loading"
    >
      <VRow>
        <VCol
          v-if="currentUser"
          cols="12"
          sm="6"
        >
          <h2 class="headline">
            Текущий пользователь
          </h2>
          <VList>
            <UserLine
              :user-id="currentUser.id"
              :disabled="ui.disabled"
              :icon="isSubbed(currentUser.id)
                ? 'mdi-bell-check'
                : 'mdi-bell'"
              :icon-color="isSubbed(currentUser.id)
                ? 'amber darken-3'
                : 'grey lighten-1'"
              :icon-tooltip="isSubbed(currentUser.id)
                ? 'Отписаться от уведомлений'
                : 'Подписаться на уведомления'"
              @click:icon="isSubbed(currentUser.id)
                ? unfollow(currentUser.id)
                : follow(currentUser.id)"
            >
              Мой профиль
            </UserLine>
          </VList>
        </VCol>
      </VRow>

      <VRow>
        <VCol>
          <h2 class="headline">
            Мои подчиненные
          </h2>
          <h3 class="mb-2 caption">
            Вам доступен просмотр событий следующих пользователей
          </h3>
          <VList
            dense
            class="mb-8"
          >
            <UserLine
              v-for="user in subordinates"
              :key="user.id"
              :user-id="user.id"
              :disabled="ui.disabled"
              :icon="isSubbed(user.id)
                ? 'mdi-bell-check'
                : 'mdi-bell'"
              :icon-color="isSubbed(user.id)
                ? 'amber darken-3'
                : 'grey lighten-1'"
              :icon-tooltip="isSubbed(user.id)
                ? 'Отписаться от уведомлений'
                : 'Подписаться на уведомления'"
              @click:icon="isSubbed(user.id)
                ? unfollow(user.id)
                : follow(user.id)"
            >
              Мой подчиненный
            </UserLine>
            <VListItem v-if="!subordinates || !subordinates.length">
              <VListItemContent>
                <VListItemSubtitle>
                  нет
                </VListItemSubtitle>
              </VListItemContent>
            </VListItem>
          </VList>
        </VCol>

        <VCol>
          <h2 class="headline">
            Мои руководители
          </h2>
          <h3 class="mb-2 caption">
            Следующие пользователи видят ваши события
          </h3>
          <VList
            dense
            class="mb-8"
          >
            <UserLine
              v-for="user in chiefs"
              :key="user.id"
              :user-id="user.id"
              :disabled="ui.disabled"
              :icon="isSubbed(user.id)
                ? 'mdi-bell-check'
                : 'mdi-bell'"
              :icon-color="isSubbed(user.id)
                ? 'amber darken-3'
                : 'grey lighten-1'"
              :icon-tooltip="isSubbed(user.id)
                ? 'Отписаться от уведомлений'
                : 'Подписаться на уведомления'"
              @click:icon="isSubbed(user.id)
                ? unfollow(user.id)
                : follow(user.id)"
            >
              Мой руководитель
            </UserLine>
            <VListItem v-if="!chiefs || !chiefs.length">
              <VListItemContent>
                <VListItemSubtitle>
                  нет
                </VListItemSubtitle>
              </VListItemContent>
            </VListItem>
          </VList>
        </VCol>
      </VRow>

      <VRow>
        <VCol
          cols="12"
          sm="6"
        >
          <h2 class="mb-2 headline">
            Прочие сотрудники
          </h2>
          <VList
            dense
            class="mb-8"
          >
            <UserLine
              v-for="user in unrelated"
              :key="user.id"
              :user-id="user.id"
              :disabled="ui.disabled"
              :icon="isSubbed(user.id)
                ? 'mdi-bell-check'
                : 'mdi-bell'"
              :icon-color="isSubbed(user.id)
                ? 'amber darken-3'
                : 'grey lighten-1'"
              :icon-tooltip="isSubbed(user.id)
                ? 'Отписаться от уведомлений'
                : 'Подписаться на уведомления'"
              @click:icon="isSubbed(user.id)
                ? unfollow(user.id)
                : follow(user.id)"
            >
              {{ user.isAdmin ? 'Администратор' : 'Сотрудник' }}
            </UserLine>
            <VListItem v-if="!unrelated || !unrelated.length">
              <VListItemContent>
                <VListItemSubtitle>
                  нет
                </VListItemSubtitle>
              </VListItemContent>
            </VListItem>
          </VList>
        </VCol>
      </VRow>
    </VSkeletonLoader>
  </DefaultLayout>
</template>
